'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'far';
var iconName = 'circle-dashed';
var width = 512;
var height = 512;
var aliases = [];
var unicode = 'e105';
var svgPathData = 'M28.2 232c12.3 0 22.5-9.3 25.2-21.3 5.3-23.9 14.7-46.2 27.4-66.2 6.6-10.4 6-24.2-2.8-32.9-10.1-10.1-26.8-9.4-34.7 2.5-18.2 27.3-31.3 58.3-37.9 91.6-2.8 14 8.5 26.3 22.8 26.3zM145 80.4c20-12.7 42.3-22.1 66.2-27.4 12-2.7 21.3-12.9 21.3-25.2 0-14.3-12.3-25.6-26.3-22.8-33.3 6.6-64.3 19.7-91.6 37.9-11.9 7.9-12.6 24.6-2.5 34.7 8.7 8.7 22.5 9.4 32.9 2.8zM280.5 484.3c0 14.3 12.3 25.6 26.3 22.8 33.3-6.6 64.3-19.7 91.6-37.9 11.9-7.9 12.6-24.6 2.5-34.7-8.7-8.7-22.5-9.4-32.9-2.8-20 12.7-42.3 22.1-66.2 27.4-12 2.7-21.3 12.9-21.3 25.2zM432.1 367.5c-6.6 10.4-6 24.2 2.8 32.9 10.1 10.1 26.8 9.4 34.7-2.5 18.2-27.3 31.3-58.3 37.9-91.6 2.8-14-8.5-26.3-22.8-26.3-12.3 0-22.5 9.3-25.2 21.3-5.3 23.9-14.7 46.2-27.4 66.2zm-320 66.8c-10.1 10.1-9.4 26.8 2.5 34.7 27.3 18.2 58.3 31.3 91.6 37.9 14 2.8 26.3-8.5 26.3-22.8 0-12.3-9.3-22.5-21.3-25.2-23.9-5.3-46.2-14.7-66.2-27.4-10.4-6.6-24.2-6-32.9 2.8zM43.4 397.9c7.9 11.9 24.6 12.6 34.7 2.5 8.7-8.7 9.4-22.5 2.8-32.9-12.7-20-22.1-42.3-27.4-66.2-2.7-12-12.9-21.3-25.2-21.3-14.3 0-25.6 12.3-22.8 26.3 6.6 33.3 19.7 64.3 37.9 91.6zM400.9 77.6c10.1-10.1 9.4-26.8-2.5-34.7-27.3-18.2-58.3-31.3-91.6-37.9-14-2.8-26.3 8.5-26.3 22.8 0 12.3 9.3 22.5 21.3 25.2 23.9 5.3 46.2 14.7 66.2 27.4 10.4 6.6 24.2 6 32.9-2.8zm31.2 66.8c12.7 20 22.1 42.3 27.4 66.2 2.7 12 12.9 21.3 25.2 21.3 14.3 0 25.6-12.3 22.8-26.3-6.6-33.3-19.7-64.3-37.9-91.6-7.9-11.9-24.6-12.6-34.7-2.5-8.7 8.7-9.4 22.5-2.8 32.9z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faCircleDashed = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;